import Immutable from 'immutable';
import {
  FLAG_GETTING_ITINERARY_GROUPS,
  GET_ITINERARY_GROUPS,
  CLEAR_ITINERARY_GROUPS,
  FLAG_ITINERARY_GROUP_ACTIVITY,
  CLEAR_ITINERARY_GROUP,
  GET_ITINERARY_GROUP,
} from '../../../actions/types/route';
import { COLLECTION_SHAPE } from '../../../config/shapes';

const INITIAL_STATE = Immutable.Map({
  all: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    loading: false,
  }),
  current: Immutable.Map({
    content: Immutable.Map(),
    activity: Immutable.List(),
  }),
});

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FLAG_GETTING_ITINERARY_GROUPS:
      return state.setIn(['all', 'loading'], action.payload);
    case GET_ITINERARY_GROUPS:
      return state.setIn(['all', 'content'], Immutable.Map(action.payload));
    case CLEAR_ITINERARY_GROUPS:
      return state.setIn(
        ['all', 'content'],
        INITIAL_STATE.getIn(['all', 'content']),
      );
    case FLAG_ITINERARY_GROUP_ACTIVITY:
      if (action.payload) {
        return state.setIn(
          ['current', 'activity'],
          state.getIn(['current', 'activity']).push(action.payload),
        );
      }

      return state.setIn(
        ['current', 'activity'],
        state.getIn(['current', 'activity']).pop(),
      );
    case GET_ITINERARY_GROUP:
      return state.setIn(['current', 'content'], Immutable.Map(action.payload));
    case CLEAR_ITINERARY_GROUP:
      return state.setIn(['current'], INITIAL_STATE.getIn(['current']));
    default:
      return state;
  }
};
